import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";
import AppTheme from "../../AppTheme";

export default function GoalHours({ hours = {} }) {
  return (
    <>
      {hours.hours > 0 ? (
        <View style={[styles.numbers]}>
          <Text style={styles.hours}>{hours.hours}</Text>
          <Text style={[styles.minutes]}>{hours.minutes || "0"}</Text>
        </View>
      ) : (
        <View style={[styles.numbers, { alignItems: "flex-end" }]}>
          <Text style={[styles.hours]}>{hours.minutes || "0"}</Text>
          <Text style={[styles.minutes, { paddingBottom: 2 }]}>m</Text>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  numbers: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "row",
  },
  hours: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  minutes: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 7,
    lineHeight: 9,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
});
